
import React, { useState } from "react";
import { useDispatch } from "react-redux";
const NATInputTyper = ({icon,alt,title}) =>{

    
       const dispatch = useDispatch();
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }

const [inputValue, setInputValue] =useState("")
const funcCalc=(val,type)=>{
    if(type=="add"){
        setInputValue(inputValue+val)
    }
    if(type=="backspace"){
        setInputValue(inputValue?.slice(0, -1))
    } if(type=="clearall"){
        setInputValue("")
    }
    
    if(type=="dot"){
        if (!(inputValue?.includes('.'))) {
            setInputValue(inputValue+'.')
  
}
    }

    if(type=="sign"){
        if ((!inputValue?.includes('-'))) {
            setInputValue('-'+inputValue)
  
}else{
     setInputValue(inputValue?.slice(1))
}
    
    
}
    
}

return(<> 
<div style={{width:"103px",marginTop:"10px"}} ><input className=""  disabled style= {{fontSize:"15px" ,marginBottom:"10px",border:"1px solid #999", borderRadius:"2px",width:"120px",margin:"0px",padding:"7px 9px"}} placeholder={`Correct Answer`} type="text"
   name="optionText" value={inputValue} onChange={(e)=>{
  
  }} />
  <div style={{display:"grid",gridTemplateColumns:"100%"}} >
    
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
      onClick={()=>funcCalc("","backspace")}
      className="calcInputBtnNum" >Backspace</div>
     </div>
      <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
     onClick={()=>funcCalc("9","add")}
     className="calcInputBtnNum" >9</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
      onClick={()=>funcCalc("8","add")}
     className="calcInputBtnNum">8</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("7","add")}
       className="calcInputBtnNum">7</div>
        </div>  <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={()=>funcCalc("6","add")}
      className="calcInputBtnNum" >6</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("5","add")}
       className="calcInputBtnNum">5</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("4","add")}
        className="calcInputBtnNum">4</div>
        </div>  <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("3","add")}
      className="calcInputBtnNum" >3</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("2","add")}
       className="calcInputBtnNum">2</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
      onClick={()=>funcCalc("1","add")}
      className="calcInputBtnNum">1</div>
        </div>    <div style={{display:"grid",gridTemplateColumns:"33% 33% 33%"}} >
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("0","add")}
      className="calcInputBtnNum" >0</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
     onClick={()=>funcCalc("","dot")}
      className="calcInputBtnNum">.</div>
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
      onClick={()=>funcCalc("","sign")}
      className="calcInputBtnNum">- +</div>
        </div>    
      <div style={{display:"grid",gridTemplateColumns:"100%"}} >
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}
     onClick={()=>funcCalc("","clearall")}
     className="calcInputBtnNum" >Clear All</div>
     </div>
        </div>


</>)
}
export default NATInputTyper;